export default {
  'imm5562.steps.sectionA': 'Principal applicant (yourself)',
  'imm5562.steps.sectionB': 'Your spouse or common-law partner',
  'imm5562.steps.sectionC': 'Your dependant children 18 years or older',

  'imm5562.title.principalApplicant':
    'Section A: Principal applicant (yourself)',
  'imm5562.description.principalApplicant':
    'List all trips you have taken outside of your country of origin or of residence in the last 10 years (or since your 18th birthday if this was less than 10 years ago). Include all trips: tourism, business, training, etc. If you did not travel outside of your country during this period, check "Did not travel."',

  'imm5562.title.partnerApplicant':
    'Section B: Your spouse or common-law partner',
  'imm5562.description.partnerApplicant':
    'List all trips your spouse or common-law partner has taken outside of their country of origin or of residence in the last 10 years (or since their 18th birthday if this was less than 10 years ago). Include all trips: tourism, business, training, etc. If they did not travel outside of their country during this period, check "Did not travel."',

  'imm5562.title.dependantApplicant':
    'Section C: Your dependant children 18 years or older',
  'imm5562.description.dependantApplicant':
    'List all trips your dependent children 18 years or older have taken outside of their country of origin or of residence in the last 10 years (or since their 18th birthday if this was less than 10 years ago). Include all trips: tourism, business, training, etc. If they did not travel outside of their country during this period, check "Did not travel."',

  'imm5562.title.formList.trips': 'Trip #',

  'imm5562.fields.haveNotTravelled': 'Did not travel',
  'imm5562.fields.fullName': 'Full name',
  'imm5562.fields.from': 'From (YYYY/MM)',
  'imm5562.fields.to': 'To (YYYY/MM)',
  'imm5562.fields.destination': 'Destination (city, country)',
  'imm5562.fields.length': 'Length (for example: 6 days)',
  'imm5562.fields.purposeOfTravel': 'Purpose of travel (for example: business)',
};
